// layouts/DashboardLayout.jsx
import React, { useState, useContext } from "react";
import { Box, Toolbar } from "@mui/material";
import Topbar from "../components/Topbar";
import Sidebar, { SIDEBAR_WIDTH } from "../components/Sidebar";
import { AuthContext } from "../theme/AuthContext";
import { Navigate, Outlet } from "react-router-dom";

export default function DashboardLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { isAuthenticated, authLoading } = useContext(AuthContext);

  if (authLoading) return null;

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return (
    <Box sx={{ display: "flex" }}>
      <Topbar onMenuToggle={() => setMobileOpen((s) => !s)} />
      <Sidebar open={mobileOpen} onClose={() => setMobileOpen(false)} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ml: { lg: `${SIDEBAR_WIDTH}px` },
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}
